var _path, _rect;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.123 17.0898C20.1084 17.0712 20.0898 17.0561 20.0684 17.0457C20.0471 17.0353 20.0237 17.0299 20 17.0299C19.9763 17.0299 19.9529 17.0353 19.9316 17.0457C19.9102 17.0561 19.8916 17.0712 19.877 17.0898L17.6895 19.8574C17.6094 19.959 17.6816 20.1094 17.8125 20.1094H19.2598V26.7188C19.2598 26.8047 19.3301 26.875 19.416 26.875H20.5879C20.6738 26.875 20.7441 26.8047 20.7441 26.7188V20.1113H22.1875C22.3184 20.1113 22.3906 19.9609 22.3105 19.8594L20.123 17.0898ZM12.8516 17.7734H14.0234C14.1094 17.7734 14.1797 17.7031 14.1797 17.6172V14.6094L25.8203 14.6094V17.6172C25.8203 17.7031 25.8906 17.7734 25.9766 17.7734H27.1484C27.2344 17.7734 27.3047 17.7031 27.3047 17.6172V13.75C27.3047 13.4043 27.0254 13.125 26.6797 13.125L13.3203 13.125C12.9746 13.125 12.6953 13.4043 12.6953 13.75V17.6172C12.6953 17.7031 12.7656 17.7734 12.8516 17.7734Z",
    fill: "currentColor"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 39.5,
    y: 39.5,
    width: 39,
    height: 39,
    rx: 19.5,
    transform: "rotate(180 39.5 39.5)",
    stroke: "currentColor",
    strokeDasharray: "2 2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.99fd5035bb17daadf32141c0d89ef6d9.svg";
export { ForwardRef as ReactComponent };